// ─────────────────────────────────────────────────────────────────────────────
// HOW A PARTNER LEAD'S SOURCE IS LABELLED.
//
// ⚠️ ONE MAP, TWO PAGES. It lived inside AdminPartnerLeads and the Partners
// drawer needed the same labels — copying it would have put two answers to "what
// does direct_invite say on screen" one file apart, and the second one drifts the
// first time a source is added.
//
// 🚨 KEYS MUST MATCH backend/constants/partnerLeadStage.js LEAD_SOURCES. A value
// the backend writes with no entry here renders as its raw key or, worse, falls
// through to a default that names a different source — direct_invite spent two
// production rows reading "Organic", under notes naming the rep who sent them.
// test/inviteLeadCoverage.test.js asserts every LEAD_SOURCES value is labelled.
//
// 🔑 AND partner_invite IS NOT partner_referral. A referral means a partner
// pointed Doorly at somebody outside their firm, or invited the broker above
// them. A firm adding its own team member referred nobody. Collapsing them would
// make "how many partners did our partners bring us" count a firm's own staff.
export const SOURCE_LABEL = {
  organic: 'Organic',
  direct_invite: 'Direct invite',
  imported: 'Imported',
  partner_referral: 'Partner referral',
  partner_invite: 'Partner invite',
  event: 'Event',
};

// ⚠️ ABSENCE IS NOT A SOURCE. A partner with no lead behind them predates the
// funnel; rendering "Organic" would assert they came to Doorly unprompted, which
// is a claim about how the business grew made out of a missing row. Callers show
// this instead, and it is deliberately not a key in the map above.
export const NO_LEAD_LABEL = 'No lead on record';
